import BaseEvent from './base_event';
import BrownAlien from '../../objects/items/moveable/brown_alien';
import GreenAlien from '../../objects/items/moveable/green_alien';
import RoboAlien from '../../objects/items/moveable/robo_alien';

const PossibleInvasions = [{
    aliens: [RoboAlien]
},{
    aliens: [BrownAlien]
},{
    aliens: [GreenAlien]
},{
    aliens: [GreenAlien, BrownAlien]
}];

export default class Invasion extends BaseEvent {
    static canOccur() { return true; }


    enter(gameState) {
        let inv = game.rnd.weightedPick(PossibleInvasions);
        this.aliens = [];
        for (let kls of inv.aliens) {
            this.aliens.push(gameState.createAlienIn(kls, gameState.getRandomRoomWithoutHero()));
        }
        this.end();
    }

}

export class RoboInvasion extends Invasion {
    static canOccur() { return true; }

    enter(gameState) {
        this.aliens = [];
        this.aliens.push(gameState.createAlienIn(RoboAlien, gameState.getRandomRoomWithoutHero()));
        this.aliens.push(gameState.createAlienIn(RoboAlien, gameState.getRandomRoomWithoutHero()));
        this.end();

    }

}

export class CockroachesInvasion extends Invasion {
    static canOccur() { return true; }

    enter(gameState) {
        this.aliens = [];
        this.aliens.push(gameState.createAlienIn(GreenAlien, gameState.getRandomRoomWithoutHero()));
        this.aliens.push(gameState.createAlienIn(GreenAlien, gameState.getRandomRoomWithoutHero()));
        this.aliens.push(gameState.createAlienIn(GreenAlien, gameState.getRandomRoomWithoutHero()));
        this.end();

    }

}


// WEBPACK FOOTER //
// ./src/states/events/invasion.js